// ============================================
// ページトップへ戻るボタン
// ============================================
export default function initPageTop() {
  pageTopBtn();
}

function pageTopBtn() {
  const goTopBtn = document.querySelector(".js-page-top");
  const contactSection = document.querySelector(".l-footer");

  if (!goTopBtn || !contactSection) return;

  // .pagetopをクリックしたら
  goTopBtn.addEventListener("click", scroll_top);

  // ページ上部へスムーズに移動
  function scroll_top() {
    window.scroll({ top: 0, behavior: "smooth" });
  }

  // スクロールされたら表示
  window.addEventListener("scroll", scroll_event);

  function scroll_event() {
    const contactRect = contactSection.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    if (window.pageYOffset > 200 && contactRect.top > windowHeight) {
      goTopBtn.style.opacity = "1";
      goTopBtn.style.pointerEvents = "auto";
    } else {
      goTopBtn.style.opacity = "0";
      goTopBtn.style.pointerEvents = "none"; // クリックイベントを無効化
    }
  }

  // 初回チェック
  scroll_event();
}
